"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiLineComment = void 0;
const react_peg_1 = require("react-peg");
const string_1 = require("./string");
function MultiLineComment() {
    return (react_peg_1.ReactPeg.createChunk("pattern", { action: ({ comment }) => {
            return { comment };
        } },
        react_peg_1.ReactPeg.createChunk("text", null, "/*"),
        react_peg_1.ReactPeg.createChunk("list", { label: "comment" },
            react_peg_1.ReactPeg.createChunk("pattern", { action: ({ globalFunction }) => globalFunction.text() },
                react_peg_1.ReactPeg.createChunk("repeat", { type: "*" },
                    react_peg_1.ReactPeg.createChunk("assert", { type: "without" },
                        react_peg_1.ReactPeg.createChunk("text", null, "*/")),
                    react_peg_1.ReactPeg.createChunk(string_1.SourceCharacter, null)))),
        react_peg_1.ReactPeg.createChunk("text", null, "*/")));
}
exports.MultiLineComment = MultiLineComment;
